import {createType, createAction} from 'store/utils';

const prefix = 'USER_INPUT';

export const ADD_SYMBOL = createType(prefix, 'ADD_SYMBOL');
export const addSymbol = (symbol: KeyboardSymbol): Action => createAction(ADD_SYMBOL, symbol);

export const HANDLE_COMMAND = createType(prefix, 'HANDLE_COMMAND');
export const handleCommand = (symbol: KeyboardSymbol): Action =>
  createAction(HANDLE_COMMAND, symbol);

export const CREATE_FROM_NUMBER = createType(prefix, 'CREATE_FROM_NUMBER');
export const createFromNumber = (value: number): Action => createAction(CREATE_FROM_NUMBER, value);

export const UPDATE_MODE = createType(prefix, 'UPDATE_MODE');
export const updateMode = (mode: UserInputMode): Action => createAction(UPDATE_MODE, mode);
